import { Injectable } from '@angular/core';
import { OfferData } from 'projects/visa-platform/src/app/shared/interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedemptionService {
  public offerDetails?: OfferData;
  public merchantLogo?: string;
  public merchantName?: string;
  public modalHeading?: string;
  public voucherCode?: string;

  private redemptionModalVisible = new BehaviorSubject<boolean>(false);
  public redemptionModalVisible$ = this.redemptionModalVisible.asObservable();
  private termsModalVisible = new BehaviorSubject<boolean>(false);
  public termsModalVisible$ = this.termsModalVisible.asObservable();

  public showRedemptionModal(
    offerDetails: OfferData | undefined,
    logo: string | undefined,
    name: string | undefined,
    heading: string | undefined,
    voucherCode: string | undefined
  ): void {
    this.redemptionModalVisible.next(true);
    this.offerDetails = offerDetails;
    this.merchantLogo = logo;
    this.merchantName = name;
    this.modalHeading = heading;
    this.voucherCode = voucherCode;
  }

  public hideRedemptionModal(): void {
    this.redemptionModalVisible.next(false);
  }

  public showTermsModal(): void {
    this.termsModalVisible.next(true);
  }

  public hideTermsModal(): void {
    this.termsModalVisible.next(false);
  }
}
